import { Pipe, PipeTransform } from '@angular/core';
import {UtcConverterService} from "./utc-convert.service";

@Pipe({
  name: 'utcToLocalTime',
  standalone: true,
})
export class UtcToLocalTimePipe implements PipeTransform {

  constructor(private _dateConverter: UtcConverterService) {
  }

  transform(date: string, args?: any): string {
    return this._dateConverter.convertUtcToLocalTime(date, args);
  }
}
